import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

const EMPTY = { title: "", description: "", due_date: "", priority: "normal", assignee_id: "" };

export const TaskDialog = ({ open, onOpenChange, initial, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (!open) return;
    setForm({ ...EMPTY, ...(initial || {}) });
    api.get("/users/directory").then(({ data }) => setUsers(data)).catch(() => {});
  }, [open, initial]);

  const save = async () => {
    if (!form.title.trim()) { toast.error("Informe o título"); return; }
    try {
      const { data } = await api.post("/tasks", { ...form, assignee_id: form.assignee_id || null, due_date: form.due_date || null });
      toast.success("Tarefa criada");
      onOpenChange(false);
      onSaved && onSaved(data);
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao criar tarefa"); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>Nova tarefa</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Título</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="task-title-field" /></div>
          <div><Label>Descrição</Label><Textarea rows={3} value={form.description || ""} onChange={(e) => setForm({ ...form, description: e.target.value })} /></div>
          <div className="grid grid-cols-2 gap-2">
            <div><Label>Prazo</Label><Input type="date" value={form.due_date || ""} onChange={(e) => setForm({ ...form, due_date: e.target.value })} data-testid="task-due-field" /></div>
            <div>
              <Label>Prioridade</Label>
              <Select value={form.priority} onValueChange={(v) => setForm({ ...form, priority: v })}>
                <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {["baixa", "normal", "alta", "urgente"].map((p) => <SelectItem key={p} value={p} className="capitalize">{p}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div>
            <Label>Responsável</Label>
            <Select value={form.assignee_id || "me"} onValueChange={(v) => setForm({ ...form, assignee_id: v === "me" ? "" : v })}>
              <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="me">Eu mesmo</SelectItem>
                {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}{u.department ? ` · ${u.department}` : ""}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter><Button onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid="task-save-button">Criar tarefa</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
